const productImageCarousel = require('./productImageCarousel');
const addToCartValidation = require('core/product/addToCartValidation');
const breadcrumb = require('./breadcrumb');
const colorSwatches = require('./colorSwatches');
const readMore = require('./readMore');
const reassurances = require('core/product/reassurances');
const sizeSelect = require('./sizeSelect');
const zoomImage = require('./zoomImage');
const isMobile = () => window.innerWidth < 992;

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {boolean} isColorSelection - Color selection action
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, isColorSelection, $productContainer ) {
  if (selectedValueUrl) {
    $.spinner().start();
    $('body').trigger('product:beforeAttributeSelect', { url: selectedValueUrl, container: $productContainer });

    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      success: function (data) {
        handleVariantResponse(data, $productContainer);
        if (isColorSelection) {
            updateUrl(data);
        }
        //updateOptions(data.product.optionsHtml, $productContainer);
        //updateQuantities(data.product.quantities, $productContainer);
        $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer });
        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    });
  }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity for Shop the look products
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
 function attributeSelectStl(selectedValueUrl, $productContainer) {
  if (selectedValueUrl) {
    $.spinner().start();
    $('body').trigger('product:beforeAttributeSelect', { url: selectedValueUrl, container: $productContainer });

    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      success: function (data) {
        let cartActions = $productContainer.find('.add-to-cart-actions');
        let wishlistActions = $productContainer.find('.js_add-to-wish-list');

        // change the id of the variation for each size
        if (cartActions && data && data.product && data.product.id) {
          cartActions.attr('data-pid', data.product.id);
        }

        if (wishlistActions && data && data.product && data.product.id) {
          wishlistActions.attr('data-pid', data.product.id);
        }

        // Switch add to cart and notify me based on availability
        const notifyAndAddToCart = $productContainer.find('.add-to-cart-switch');

        if (notifyAndAddToCart) {
          if (notifyAndAddToCart.hasClass('show-notify-me') && data.product.available) {
            notifyAndAddToCart.removeClass('show-notify-me');
          } else if (!notifyAndAddToCart.hasClass('show-notify-me') && !data.product.available) {
            notifyAndAddToCart.addClass('show-notify-me');
          }
        }

        // Update wishlist icon
        const $addTowishListIcon = $productContainer.find('.js_add-to-wish-list');

        if ($addTowishListIcon.length > 0 && data.product && data.product.id) {
          $addTowishListIcon.toggleClass('active', data.product.inWishList);
          $addTowishListIcon.attr('data-pid', data.product.id);
        }

        $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer });
        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    });
  }
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
  let availabilityValue = '';
  const availabilityMessages = response.product.availability.additionalMessages;
  let messages= $('.js-additional-messages');
  availabilityMessages.forEach(function (message) {
    availabilityValue += `<div class="additional-msg mm-form-message -info mb-0.5">
                            <p class="m-0">${message}</p>
                          </div>`
  });
  $(messages).each(function () {
    $(this).html(availabilityValue);
  });

  availabilityValue = '';

  $($productContainer).trigger('product:updateAvailability', {
    product: response.product,
    $productContainer: $productContainer,
    message: availabilityValue,
    resources: response.resources,
  });

  // update notifyme
}

/**
 * Updates the recommendation carousel in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after the
 *                            render of new recommendations
 */
 function updateStlRecommendations(response) {
  if (response && response.queryString && response.product && response.product.stlProductsRecommendations) {
    var updateRecommendationUrl = $('.stl-update-recommendation').data('action');

    if (updateRecommendationUrl) {
      updateRecommendationUrl = updateRecommendationUrl + '?' +  response.queryString;

      $.ajax({
        url: updateRecommendationUrl,
        method: 'GET',
        success: function (data) {
          if (data) {
            // repopulate the carousel
            $('.stl-update-recommendation').html(data)

            productRecommendationsCarousel();
          }
        }
      });
    }
  }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
  // Update variation attributes
  if (response.product && response.product.variationAttributes) {
    updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
  }

  // Update product name and number
  updateProductDetails(response.product.defaultVariant ? response.product.defaultVariant : response.product, $productContainer);

  // Update size warning

  if (response.sizeMsg){
    var warningMsg = `<div class="mm-form-message -info-grey mb-0.5">
                            ${response.sizeMsg}
                          </div>`;
    $productContainer.find('.product-size-message-warning').html(warningMsg);

    var warningMsg = `<div class="mm-form-message -info-grey pb-0">
                            ${response.sizeMsg}
                          </div>`;
    $productContainer.find('.product-size-message-mobile-section').html(warningMsg);
    $('.size-switch.mm-switch__toggle').addClass('no-margin');
  }
  else {
    $productContainer.find('.product-size-message-warning').html('');
    $('.size-switch.mm-switch__toggle').removeClass('no-margin');
  }

  // Update pricing
  let $priceSelector = $('.prices .price', $productContainer).length ? $('.prices .price', $productContainer) : $('.prices .price');
  if (response.product && response.product.defaultVariant && response.product.defaultVariant.price && response.product.defaultVariant.price.html) {
    $priceSelector.replaceWith(response.product.defaultVariant.price.html);
  } else if (response.product && response.product.price && response.product.price.html) {
    $priceSelector.replaceWith(response.product.price.html);
  }

  // Update images
  updateImages(response.product);

  // Update availability
  updateAvailability(response, $productContainer);

  // Update Shop the Look Recommendations
  updateStlRecommendations(response);

  // manage bopis
  let bopisBtn = $('button.bopis-btn');
  bopisBtn.attr('data-pid', response.product.id);

  $('#product-show .store-item .item-error-message-container').text('');

  // update preorder
  updatePreorderDetails(response.product.defaultVariant ? response.product.defaultVariant : response.product, $productContainer);

  // Enable "Add to Cart" button if all required attributes have been selected
  let addToCartBtn = $('.add-to-cart-actions');
  const notifyAndAddToCart = $('.add-to-cart-switch');
  addToCartBtn.trigger('product:updateAddToCart', {
    product: response.product,
    $productContainer: $productContainer,
  });

  notifyAndAddToCart.toggleClass('show-notify-me', !(response.product.available));

  if($('.pdp-apple-pay-button-fake') ){
    $('.apple-pay-pdp-button').attr('sku', response.product.id);
    $('.pdp-apple-pay-button-fake').toggleClass('d-none', (response.product.available));
    $('.pdp-apple-pay-button').toggleClass('d-none', !(response.product.available));
  }


  // Update wishlist icon
  const $addTowishListIcon = $productContainer.find('.js_add-to-wish-list');

  if ($addTowishListIcon.length > 0) {
    $addTowishListIcon.toggleClass('active', response.product.inWishList);
    $addTowishListIcon.attr('data-pid', response.product.id);
  }
  productImageCarousel.reInitCarousels();

  $('.js-dynamic-delivery-date').html('');
  if(response.dddEnabled && response.product.isVariant && !response.product.isPreOrder && response.product.isOrderable) {
    $('.js-dynamic-delivery-date').attr('data-pid', response.product.id);
    $('.js-dynamic-delivery-date').attr('data-runservice', 'true');

    $(document).trigger('ddd:reinit');
  }

  //Rollback MCR-3838
  //updateUrl(response);

}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 * @param {Object} attrs - Attributes
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
  let $attributeValues;
  let $attrColor = false;
  attrs.forEach((attr) => {
    $attributeValues = $productContainer.find('.select-' + attr.id);
    let $attrValue;
    $attrColor = attr.attributeId === 'color' ? true : false;
    attr.values.forEach(function (attrValue) {
      $attrValue = $attributeValues.find('[data-attr-value="' + attrValue.id + '"]');
      $attrValue.val(attrValue.url);

      if (!attrValue.selectable) {
        $attrValue.text(attrValue.displayValue + ' ' + msgs.variationUnavailable);
        $attrValue.addClass('disabled');
      } else {
        $attrValue.text(attrValue.displayValue);
        $attrValue.removeClass('disabled');
      }

      if (attrValue.selected) {
        $attrValue.prop('selected', true);

        if($attrColor && $('.default-attr-option').attr('data-attr-color') !== attrValue.id) {
          $('.default-attr-option').attr('data-attr-color', attrValue.id);
          var urlColor = attrValue.url.indexOf('size=') > -1 ? attrValue.url.substring(0, attrValue.url.indexOf('size=')+ 'size='.length) + attrValue.url.substring( attrValue.url.lastIndexOf('&pid='), attrValue.url.length) : attrValue.url;
          $('.default-attr-option').val(urlColor);
        }

      } else {
        $attrValue.removeAttr('selected');
      }
    });
  });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 * @param {Object} product - Product
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateProductDetails(product, $productContainer) {
  // Update product number
  $productContainer.find('.product-id-content').text(product.modelFabricColor);

  // Update product name
  $productContainer.find('.product-name .title').text(product.productNamePDP);

  // Update product description
  $productContainer.find('.product-description .description-content').text(product.productDescriptionLong);

  // Update product name in breadcrumb
  let breadcrumbLastItem = $productContainer.find('.breadcrumb-item.last-element > a');
  if (breadcrumbLastItem) {
    breadcrumbLastItem.find('p').text(product.productNamePDP);
    breadcrumbLastItem.attr('href', product.selectedProductUrl);
  }

  // Update accordion details
  let careInstructionsParagraph = $productContainer.find('.care-instructions-review > .care-instructions-description');
  if (careInstructionsParagraph) {
    careInstructionsParagraph.text(product.careInstructions);
  }

  let editorialCompositionParagraph = $productContainer.find('.editorial-composition > .editorial-composition-description');
  if (editorialCompositionParagraph) {
    editorialCompositionParagraph.text(product.editorialComposition);
  }

  let sizeAndFitParagraph = $productContainer.find('.size-and-fit-review .size-and-fit-content');
  if (sizeAndFitParagraph) {
    sizeAndFitParagraph.html('');
    product.sizeAndFiteNotes.forEach(function (s) {
      sizeAndFitParagraph.append('<li>' + s + '</ul>');
    });
  }

  let modelImageSizeColorParagraph = $productContainer.find('.model-image-size-color');
  if (modelImageSizeColorParagraph) {
    modelImageSizeColorParagraph.text(product.modelImageSizeColor);
  }
}


function updatePreorderDetails(product, $productContainer){
  if (product.isPreOrder){
    // Show badge
    $productContainer.find('.preorder-badge-wrapper').removeClass("d-none");

    // Update date
    $productContainer.find('span.productPreorderReleaseDate').text(product.preorderReleaseDate);

    // Show info box
    $productContainer.find('.preorder-release-date').removeClass("d-none");
  }
  else {
    // Hide badge
    $productContainer.find('.preorder-badge-wrapper').addClass("d-none");

     // Hide info box
    $productContainer.find('.preorder-release-date').addClass("d-none");

  }

  $productContainer.find('.price.default-option .preorder-badge-wrapper').addClass("d-none");

}
function compileImageTemplate(template, img, index) {
  const productSlide = template.cloneNode(true);
  productSlide.dataset.index = index;
  const mask = productSlide.querySelector('.mm-mask-9x16-');

  if (mask) {
    const maskNumber = () => (Math.floor(Math.random() * (10 - 1) + 1)).toString();
    mask.classList.remove('mm-mask-9x16-');
    mask.classList.add(`mm-mask-9x16-${maskNumber()}`);
  }

  const productImg = productSlide.querySelector('img');
  productImg.dataset.zoomImg = img.url;
  productImg.alt = img.alt;
  let srcSetString = '';
  productImg.dataset.srcset.split(',').forEach((w,i) => {
    if (w.includes('x')){
      const width = productImg.dataset.formats.split(',')[i]; //get the first numeric part
      const retina = w.match(/(\d+)x/)[1]; //get the numeric part before 'x'
      srcSetString += `${img.dis[width]} ${retina}x,`
    } else if (w.includes('w')){
      const width = w.match(/(\d+)w/)[1];; //get the numeric part before 'w'
      srcSetString += `${img.dis[width]} ${width}w,`
    }
  });

  productImg.dataset.srcset = srcSetString;
  productImg.srcset = srcSetString;

  return productSlide;
}

function compileVideoTemplate(template, productVideo, index, container, isThumb) {
  const isMM6 = document.body.classList.contains('mm6-body');
  const productSlide = template.cloneNode(true);
  productSlide.dataset.index = index;
  const mask = productSlide.querySelector('.mm-mask-9x16-');
  if (mask) {
    const maskNumber = () => (Math.floor(Math.random() * (10 - 1) + 1)).toString();
    mask.classList.remove('mm-mask-9x16-');
    mask.classList.add(`mm-mask-9x16-${maskNumber()}`);
  }
  productSlide.querySelector('img').remove();
  const videoElement = document.createElement("video");

  let videoElementClass = '';

  if (typeof shaka !== 'undefined') {
    videoElementClass = 'shakamediaplayer';
    videoElement.setAttribute('class', videoElementClass);
  }

  videoElement.setAttribute('tabindex', '0');
  videoElement.setAttribute('playsinline', true);
  videoElement.setAttribute('loop', true);
  videoElement.muted =true;
  videoElement.setAttribute('autoplay', true);
  const videoId = new Date().getTime();
  videoElement.setAttribute('id', 'video_' + videoId);
  let targetContainer = isThumb ? productSlide.querySelector('.thumbnail-button') : productSlide.querySelector('.swiper-zoom-container');
  if(isThumb){
    if (typeof shaka !== 'undefined') {
      targetContainer.append(videoElement);
    }

    productSlide.classList.add('product-slide-thumb-video');
  } else {

    if (typeof shaka !== 'undefined') {
      const videoMaskContainer = document.createElement("div");
      videoMaskContainer.setAttribute('class', isMM6 ? 'mask-container img-mm-mask-'+randomNumber() : 'mask-container');
      videoMaskContainer.append(videoElement);
      targetContainer.append(videoMaskContainer);
    }
  }
  container.prepend(productSlide);

  if (typeof shaka !== 'undefined') {
    videoElement.setAttribute('src', productVideo);
    videoElement.classList.add('initialized');
    initShaka(videoElement, productVideo);
  }

  return productSlide;
}

async function initShaka(video, url) {
  const player = new shaka.Player();
  await player.attach(video);

  // Attach player to the window to make it easy to access in the JS console.
  window.player = player;

  // Listen for error events.
  player.addEventListener('error', onErrorEvent);

  // Try to load a manifest.
  // This is an asynchronous process.
  try {
    await player.load(url);
    // This runs if the asynchronous load is successful.
    console.log('The video has now been loaded!');
  } catch (e) {
    video.classList.remove('initialized');
    video.classList.add('uninitialized');
    // onError is executed if the asynchronous load fails.
    onError(e);
  }

  function onErrorEvent(event) {
    // Extract the shaka.util.Error object from the event.
    onError(event.detail);
  }

  function onError(error) {
    // Log the error.
    console.error('Error code', error.code, 'object', error);
  }
}

function randomNumber() {
  var min = 1, max = 10;
  return (Math.floor(Math.random() * (max - min) + min)).toString();
}

function updateUrl(response){
    if (response.product.mfcURL){
        window.history.pushState({path: response.product.mfcURL}, "", response.product.mfcURL);
    }
}

function updateImages(product) {
  const productData = product.defaultVariant ? product.defaultVariant : product;
  const productSlideTemplate = document.querySelector('#carousel-image-template .product-slide');
  const productThumbTemplate = document.querySelector('#carousel-thumb-template .product-slide');
  const imagesWrapper = document.querySelector('.image-carousel-col .swiper-wrapper');
  imagesWrapper.innerHTML = '';
  const thumbsWrapper =  document.querySelector('.thumbs-carousel-col .swiper-wrapper');
  const selectedThumb =  Array.from(thumbsWrapper.querySelectorAll('.swiper-slide')).find(e => e.classList.contains('selected'));
  const selectedThumbIndex = selectedThumb ? selectedThumb.dataset.index : 0;
  thumbsWrapper.innerHTML = '';
  productData.swipeableImages.large.forEach((img, index) => {
    imagesWrapper.append(compileImageTemplate(productSlideTemplate, img, index));
    thumbsWrapper.append(compileImageTemplate(productThumbTemplate, img, index));
  });

  // IBT-3745
  const imagesWrappers = document.querySelector('.image-carousel-col').querySelectorAll('.swiper-wrapper');
  imagesWrappers.forEach(element => {
    if (element === imagesWrapper) return;
    element.innerHTML = imagesWrapper.innerHTML;
  });

  if(product.productVideo){
    imagesWrappers.forEach(element => compileVideoTemplate(productSlideTemplate, product.productVideo, -1, element, false));
    compileVideoTemplate(productThumbTemplate, product.productVideo, -1, thumbsWrapper, true);
  }
  //TODO: Check Marni for video and editorial images
  if (isMobile()){
    imagesWrappers.forEach(element => {
      const swiper = element.closest('.swiper').swiper;
      swiper && swiper.update();
    });
  } else {
    thumbsWrapper.querySelector(`[data-index="${selectedThumbIndex}"]`).classList.add('swiper-slide-active');

    const swiper = thumbsWrapper.closest('.swiper').swiper;
    if (swiper.slides.length > 3) {
      swiper.init();
      swiper.update();
    } else {
      swiper.destroy(false, true);
    }
  }
}

/**
 * Show validation popup
 * @param {Objecct} responseData response data
 */
function showNotificationPopup(responseData) {
  if (responseData) {
    let validationPopup;
    const findInStore = $('#findInStoreModal');

    if (responseData.sameProductError) {
      if (responseData.sameProductReason === 'addedForDelivery') {
        validationPopup = $('.js_addedForDelivery');
      } else if (responseData.sameProductReason === 'alreadyCustomized') {
        validationPopup = $('.js_alreadyCustomized');
      } else {
        validationPopup = $('.js_addedForPickup');
      }
    } else if (responseData.preorderProductError) {
      validationPopup = $('.js_addedForPreorder');
    } else if (responseData.giftcardError) {
      validationPopup = $('.js_giftcard__modal-error-cart');
    }

    if (validationPopup && validationPopup.length > 0) {
      findInStore.modal('hide');
      validationPopup.modal('show');
    }
  }
}

/**
 * Call add to cart
 *
 * @param {string} productId
 */
function submitProductToCart(productId) {
  // console.log('submitProductToCart', productId);
  $.spinner().start();
  const addToCartUrl = $('.add-to-cart-url').val();
  const btnAddToCart = $('.add-to-cart');

  if (addToCartUrl && productId) {
    const form = {
      pid: productId,
      quantity: 1,
    };
    btnAddToCart.prop('disabled', true);
    const errorBox = $('.details-column-content .add-to-cart-error-messaging');
    $.ajax({
      url: addToCartUrl,
      method: 'POST',
      data: form,
      success: function (responseData) {
        btnAddToCart.prop('disabled', false);
        // debugger;
        if (!responseData.error) {
          // Tealium event "Cart Addition"
          $('body').trigger('product:afterAddToCart', responseData);

          var applePayNotificationWrapper = $('.notifications-apple-pay-button');
          if (applePayNotificationWrapper.length) {
            applePayNotificationWrapper.addClass('d-none')
          };
          // show notification on mobile
          if (isMobile()) {
            const event = new CustomEvent('notification:show', {
              detail: {
                message: responseData.message,
                icon: true,
                linkCart: false,
                linkWishlist: false,
                addToCartModal: true,
                addToCartContent: responseData.addToCartContent
              }
            });

            if (applePayNotificationWrapper.length) {
              $.ajax({
                url: applePayNotificationWrapper.data('url'),
                method: 'GET',
                success: function(result) {
                  if (result.showApplePayButton) {
                    applePayNotificationWrapper.removeClass('d-none');
                  }
                }
              });
            }

            document.body.dispatchEvent(event);
          } else {
            // Open minicart
            $('.minicart-action').trigger('click');
            $('#layer-minicart').addClass('is-open');
          }

          const mincartButtons = [...document.querySelectorAll('.js-button-minicart')];
          mincartButtons.forEach((item) => {
            item.classList.contains('-dot-info') ? null : item.classList.add('-dot-info');
          });

          if (!errorBox.hasClass('d-none')) {
            errorBox.addClass('d-none');
          }

          $('.size-switch.mm-switch__toggle').removeClass('no-margin');
        } else {
          showNotificationPopup(responseData);
          errorBox.removeClass('d-none');
          $('.details-column-content .add-to-cart-error-messaging > div').html(responseData.message);
          $('.size-switch.mm-switch__toggle').addClass('no-margin');
        }

        document.getElementById('main-overlay').style.display = 'none';
        $.spinner().stop();
      },
      error: function () {
        btnAddToCart.prop('disabled', false);
        document.getElementById('main-overlay').style.display = 'none';
        $.spinner().stop();
      },
    });
  }
}

/**
 * Init Product Recommendations Carousel
 *
 */
 function productRecommendationsCarousel() {
  var numberOfSlides = $('[data-number-of-slides]').length ? $('[data-number-of-slides]')[0].dataset.numberOfSlides : 0;

  var settings = {
    slidesPerView: 1,
    observer: true,
    loop: true,
    spaceBetween: 8,
    createElements: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 5,
        watchOverflow: true,
        loop: false,
        spaceBetween: 8,
      }
    }
  };

  if (numberOfSlides >= 6) {
    settings.breakpoints = {
      640: {
        slidesPerView: 5,
        loop: true,
        spaceBetween: 8,
      }
    }
  };

  const swiper = new Swiper('.product-carousel-products-init', settings);
}

function updateCountrySelector() {
  const pid = document.querySelector('.product-detail').getAttribute('data-pid');
  if (pid) {
    const countrySelectorHeader = document.querySelector('.country-selector-header');
    const countrySelectorFooter = document.querySelector('.country-selector-footer');
    countrySelectorHeader.setAttribute('href', countrySelectorHeader.getAttribute('href') + '?pid=' + pid);
    countrySelectorFooter.setAttribute('href', countrySelectorFooter.getAttribute('href') + '?pid=' + pid);
  }
}

function initModules(){
  productImageCarousel.init();
  breadcrumb.scrollToTheEnd();
  colorSwatches.bindEvents();
  sizeSelect.bindEvents();
  readMore.bindEvents();
  readMore.hideOrShowReadMore();
  zoomImage.init();
  reassurances.copyID();
  productRecommendationsCarousel();
  updateCountrySelector();
  checkApplepay();
  activateScrollBehavior();
}

function getCustomerWishlist() {
  let url = document.querySelector('.js-button-wishlist') ? document.querySelector('.js-button-wishlist').getAttribute('data-customer-wishlist-products') : null;

  if(url){
    $.ajax({
      url: url,
      method: 'GET',
      success: function (responseData) {
        if(responseData) {
          $('.js_add-to-wish-list.active').removeClass('active');
          if(responseData.wishlistIDS && responseData.wishlistIDS.length > 0) {
            responseData.wishlistIDS.forEach(function(item) {
              $(".js_add-to-wish-list[data-pid=" + item + "]").addClass('active');
            });
          }
        }
      },
      error: function () {
        console.log('Error while getting notify content');
      },
    });
  }
}

function fastCheckout(cartType, buttonPosition) {
  var fastCheckoutUrl = $(".track-fast-checkout-url").val();
  var fastCheckoutData = cartType + '_fast_' + buttonPosition;

  if(fastCheckoutUrl) {
    $.ajax({
      url: fastCheckoutUrl,
      method: 'GET',
      dataType: 'json',
      data: { fastPayment: fastCheckoutData},
      success: function (data) {
        $('body').trigger('checkout:fastCheckoutStart', [cartType, buttonPosition]);
      }
    });
  }
}

function checkApplepay() {
  const ipayWrapperURL  = $('.ipay-wrapper') ?  $('.ipay-wrapper').data('url') : false;
  if(ipayWrapperURL) {
    $.ajax({
      url: ipayWrapperURL,
      method: 'GET',
      success: function (responseData) {
        if(responseData.applePayEnabled && responseData.ipayButton ) {
          $('.ipay-wrapper').html(responseData.ipayButton);
          $('#apple-pay-button-fake').on('click', function() {
            $('.add-to-cart-actions').trigger('click');
          });
        }
      },
      error: function () {
        console.log('Error while getting apple pay configuration');
      },
    });

  }

}

function activateScrollBehavior() {
  const addToCartWrapper = $('.col-details .add-to-cart-mobile-section');
  const addToCartWrapperPlaceholder = $('.col-details .add-to-cart-mobile-placeholder');

  $(document).scroll(function () {
    if (window.isMobile()) {
      var documentHeight = addToCartWrapper[0].getBoundingClientRect().top + window.scrollY;
      var toScroll = documentHeight - window.innerHeight;
      var buttonHeight = addToCartWrapper[0].clientHeight + parseFloat(addToCartWrapper.css('margin-bottom'));
      var toScrollPosition = parseInt(toScroll + buttonHeight);

      if (window.scrollY > toScrollPosition ) {
        addToCartWrapperPlaceholder.css({'height': '0px'});
        addToCartWrapper.find('.custom-switch').removeClass('sticky-cta');
      } else {
        addToCartWrapperPlaceholder.css({'height': addToCartWrapper[0].getBoundingClientRect().height+'px'});
        addToCartWrapper.find('.custom-switch').addClass('sticky-cta');
      }
    }
    else {
      addToCartWrapper.removeClass('sticky-cta');
    }
  });
}

module.exports = {
  bindEvents: function(){
    if(document.readyState !== 'loading') {
      initModules();
    } else {
      document.addEventListener("DOMContentLoaded",function(){
        initModules();
      });
    }
  },
  setWishListIcon: function() {
    $(document).ready(function() {
      getCustomerWishlist();
    });
  },
  selectAttribute: function () {
    $(document).on('change', 'select[class*="select-"]', function (e) {
      e.preventDefault();

      let isStlSelectAttribute = false;
      let isColorSelection = e.currentTarget.classList.contains('js-select-color');
      $('.size-not-selected-message').addClass('visually-hidden');

      $('.size-switch.mm-switch__toggle').removeClass('no-margin');

      // Check if it's a shop the look prd
      let shopTheLookPDP = $(this).closest('.stl-pdp');
      if (shopTheLookPDP && shopTheLookPDP.find('.add-to-cart-actions').length > 0) {
        let cartActions = shopTheLookPDP.find('.add-to-cart-actions');
        if (cartActions.attr('data-stl-add-to-cart') === 'true') {
          isStlSelectAttribute = true;
        }
      }

      // It's a shop the look prd
      if (isStlSelectAttribute) {
        let $productContainerStl = $(this).closest('.stl-pdp');
        attributeSelectStl(e.currentTarget.value, $productContainerStl);
      } else {
        let $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
          $productContainer = $(this).closest('.product-detail');
        }
        $(this).parent().removeClass('invalid');
        attributeSelect(e.currentTarget.value, isColorSelection, $productContainer);
      }
    });
  },
  updateAddToCart: function () {
    $('.add-to-cart-actions').on('product:updateAddToCart', function (e, response) {
      const product = response.product;
      //const isMaster = product.productType === 'master';
      response.$productContainer.find('.add-to-cart').attr('data-pid', product.id);
    });
  },
  addToCart: function () {
    $('.add-to-cart-actions').on('click', function (e) {
      // console.log('click', e);
      $('body').trigger('product:beforeAddToCart', this); // eslint-disable-line no-undef
      // Check if it's a shop the look prd
      if ($(this).attr('data-stl-add-to-cart') === 'true') {
        let $productContainerStl = $(this).closest('.stl-pdp');

        if (addToCartValidation($productContainerStl)) {
          submitProductToCart($(this).attr('data-pid'));
        }
      } else {
        let $productContainer = $(this).closest('.product-detail');
        if (addToCartValidation($productContainer)) {
          submitProductToCart($('button.add-to-cart').attr('data-pid'));
        } else {
          $('.size-not-selected-message').removeClass('visually-hidden');

          $('.size-switch.mm-switch__toggle').addClass('no-margin');
        }
      }
    });
  },
  trackFastCheckout: function(){
    $(document).on('DOMNodeInserted', function(e) {
      if($(e.target).hasClass('paypal-checkout-sandbox')) {
        if(!document.activeElement.parentElement.parentElement.classList.contains('paypal-cart-button-minicart')){
            fastCheckout('paypal', 'pdp');
        }
      }
    });

    $('body').on('click', '.apple-pay-pdp-button', function() {
      fastCheckout('applepay', 'pdp');
    });
  },
  scrolToFirstBreadcrumb: function() {
   document.getElementById("breadcrumb").scrollLeft = 0;
  }
};
